/**
 * Convert data to text format
 * @param data - Data including matrix, meta, ids, and x values
 * @param options - Conversion options
 * @returns Formatted text string
 */
export function convertToText(data, options = {}) {
    const { fs = '\t', rs = '\n' } = options;
    const { matrix, meta, ids, x } = data;
    const allKeysObject = {};
    for (const metum of meta) {
        if (metum) {
            for (const key of Object.keys(metum)) {
                const type = typeof metum[key];
                if (type === 'number' || type === 'string' || type === 'boolean') {
                    allKeysObject[key] = true;
                }
            }
        }
    }
    const allKeys = Object.keys(allKeysObject);
    const lines = [];
    let line = ['id', ...allKeys, ...x];
    lines.push(line.join(fs));
    for (let i = 0; i < ids.length; i++) {
        line = [ids[i]];
        for (const key of allKeys) {
            line.push(removeSpecialCharacters(meta[i][key]));
        }
        line.push(...matrix[i]);
        lines.push(line.join(fs));
    }
    return lines.join(rs);
}
function removeSpecialCharacters(value) {
    if (typeof value !== 'string') {
        return value;
    }
    return value.replaceAll(/[\t\n\r]+/g, ' ');
}
//# sourceMappingURL=convertToText.js.map